export default class Technicolor3StripProcess {

    constructor() {
        this.blockName = 'technicolor-3-strip-process';
        this.control = 'LUTsliders';
        this.defaultOpacity = 50;
        this.maxValue = 100;
        this.minValue = 0;
    }
    
    async addBlock(blockNum = lutify.blocks.length, data) {
        data.control = this.control;

        UI.createAdjustmentBlockTemplate(this.blockName, blockNum, data);
        let $element = $(UI.getAdjustmentBlock(blockNum));

        $element.trigger('click');

        $element.find('.adjustmentBlock-slider').on('input', _ => this.sliderHandler($element));
        $element.find('.adjustmentBlock-range').on('change', _ => this.rangeHandler($element));

        blocks.add({
            name: "technicolor3StripProcess",
            control: data.control,
            category: data.category,
            passes: [null],
            blockNum,
            blendingMode: 0,
            blendingModeName: 'Normal',
            opacity: this.defaultOpacity, // still need this?
            values: {
                opacity: this.defaultOpacity,
            }
        });


        UI.appendBlockLoadingSpinner($element);
        await this.load(data);
        UI.removeBlockLoadingSpinner($element);

        // NOTE maybe need to re-write : add empty pass then replace with lut pass (like we do with LUTcontrols when a selection is made)
        lutify.getActiveBlock().passes[0] = this.addPass(data.category);
        
        $element.find('.expand_options').trigger('click', [false]);
        $element.find('.controls-wrapper .switch input').trigger('click');
        UI.scrollToBlock(blockNum);
    }


    async load(data) {
        // Initially when loading for first time.
        if (typeof luts.loaded[data.control].controls[data.category] == 'undefined') {
            luts.loaded[data.control].controls[data.category] = { status:'idle', total: null, fetched: null };
            luts[data.control][data.category] = [];
        }

        // When all luts fetched, don't fetch again.
        if (luts.loaded[data.control].controls[data.category].status == 'loaded') return;

        if (luts.loaded[data.control].controls[data.category].status == 'idle') {
            luts.loaded[data.control].controls[data.category].status = 'loading';

            let fetchedLUTs = await luts.fetchLUTcontrols(data);
            await luts.load(fetchedLUTs, luts[data.control][data.category]);

            luts[data.control][data.category].forEach((LUT, key) => {
                LUT.control = data.control;
                LUT.category = data.category;
            });

            luts.loaded[data.control].controls[data.category].fetched += fetchedLUTs.length;
            luts.loaded[data.control].controls[data.category].status = 'loaded';
        }

         // If we add more of the same block while the initial is being in 'loading'
         else if (luts.loaded[data.control].controls[data.category].status == 'loading') {
            return await new Promise(resolve => {
                let interval = setInterval(_ => {
                    if (luts.loaded[data.control].controls[data.category].status == 'loaded') {
                        clearInterval(interval);
                        resolve();
                    }
                }, 500);
            });
        }
    }
    
    
    addPass(category) {
        let LUT = luts[this.control][category][0];
        let pass = gpu.createLUTPass(LUT.texture);
        pass.uniforms.opacity.value = this.defaultOpacity * 0.01;
        gpu.addPassToComposer(pass, 'toMiddle');
        return pass;
    }


    sliderHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;

        let sliderValue = UI.getAdjustmentBlock_sliderValue($el);
        UI.setAdjustmentBlock_rangeValue($el, sliderValue);
        
        lutify.getActiveBlock().opacity = sliderValue;
        lutify.getActiveBlock().values.opacity = sliderValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = sliderValue * 0.01;
        gpu.render()
    }


    rangeHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;
        
        let rangeValue = UI.getAdjustmentBlock_rangeValue($el);
        if (rangeValue > this.maxValue) {
            rangeValue = this.maxValue;
            UI.setAdjustmentBlock_rangeValue($el, rangeValue);
        }
        if (rangeValue < this.minValue) {
            rangeValue = this.minValue;
            UI.setAdjustmentBlock_rangeValue($el, rangeValue);
        }
        
        UI.setAdjustmentBlock_sliderValue($el, rangeValue);

        lutify.getActiveBlock().opacity = rangeValue;
        lutify.getActiveBlock().values.opacity = rangeValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = rangeValue * 0.01;
        gpu.render()
    }


    applyChanges($block, values, blockData) {
        UI.setAdjustmentBlock_rangeValue($block, values.opacity);
        $block.find('.adjustmentBlock-range').trigger('change');
        if (blockData.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${blockData.blendingMode}"]`).trigger('click');
    }
}